import { Injectable } from "@angular/core";
import {User} from "../models/user";
import {Role} from "../models/role";
import {HTTPService} from "./http.service";
import { PaginatedResultResponse } from "../models/paginated-results-response";

@Injectable()
export class UserService {
    private users:User[];

    constructor(private dac$http:HTTPService) {
        //  let admin = new User();
        // admin.username = "admin";
        // admin.id = 1;
        // admin.role = Role.Admin;

        // let user = new User();
        // user.username = "snielson";
        // user.id = 2;

        // let user2 = new User();
        // user2.username = "kskinner";
        // user2.id = 3;
        // this.users = [admin, user, user2];
    }

    getUsers() : Promise<User[]> {
        return this.dac$http.get("users/").then((serverResponse) => {
            let responseUsers = serverResponse.json() as any[];
            let users = responseUsers.map((u) => this.mapUser(u));
            return users;
            // let data = serverResponse.json() as PaginatedResultResponse
            // data.results = data.results.map((record) => {
            //     let user = new User();
            //     Object.assign(user, record);
            //     if (record.role) {
            //         user.role = record.role.id;
            //     }
            //     return user;
            // });
            // return data.results;
        });
    }

    createUser(userToCreate:User) {
        return this.dac$http.post("users/", userToCreate).then((response) => {
            let u = response.json();
            return this.mapUser(u);
        });
    }

    saveUser(user:User) {
        return this.dac$http.post("users/" + user.id + ".json", user).then((response) => {
            return user;
        });
    }

    getUser(id:number) {
        return this.getUsers().then((users) => {
            let user = users.find(user => user.id == id);
            let newUser = new User();
            let copied = Object.assign(newUser, user);
            return copied;
        });
    }

    isDuplicateUsername(username:string) : Promise<boolean> {
        // need to make sure we handle special characters
        return this.dac$http.post("users/check-username", {_username: username})
            .then((response) => {
                if (response) {
                    return true;
                }
        }).catch((error) => {
            if (error.status === 404) {
                return false;
            }
            throw error;
        });
    }

    restoreUser(userToRestore:User) {
        let user = new User();
        Object.assign(user, userToRestore);
        user.enabled = true;
        return this.saveUser(user).then(savedUser => {
            userToRestore.enabled = true;
            return userToRestore;
        });
    }

    archiveUser(userToArchive:User) {
        let user = new User();
        Object.assign(user, userToArchive);
        user.enabled = false;
        return this.saveUser(user).then(savedUser => {
            userToArchive.enabled = false;
            return userToArchive;
        });
    }

    // we removed the API endpoint to delete users
    // TODO: stephen if we ever enable user deletion again add this back in.
    // deleteUser(userToDelete:User, userToReassignTo:User) {
    //     return this.dac$http.delete("users/" + userToDelete.id + ".json", {reassignUserId: userToReassignTo.id});
    // }

    private mapUser(u:any) {
        let user = new User();
        Object.assign(user, u);
        return user;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/user.service.ts